module.exports = __webpack_public_path__ + "0587794ad30e008b09e5e675701e928c.mp3";